import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useErrorCallback} from "hooks";
import {DataCollection} from "utils";
import {OwnedProject} from "api-client";
import {Container, Loader, PaymentScheduleModal, Section} from "components";
import styles from './MyOwnedProjects.module.scss';
import {createProjectProvider} from "../../../../di";
import MyOwnedProject from "../../../../components/pages/projects/MyOwnedProject";

const MyOwnedProjects = () => {
  const handleError = useErrorCallback();
  const [modalLoading, setModalLoading] = useState(false);
  const [isModalActive, setIsModalActive] = useState(false);
  const [projectUuid, setProjectUuid] = useState('');
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] =
        useState<DataCollection<OwnedProject>>(new DataCollection());

  const loadData = useCallback(async (page: number, perPage: number): Promise<void> => {
    setLoading(true);
    try {
      const provider = await createProjectProvider();
      const projects = await provider.getOwned(page, perPage);
      const dataCollection = new DataCollection<OwnedProject>();
      dataCollection.setCollection(projects);
      setProjects(dataCollection);
    } catch (err) {
      if (err instanceof Error) await handleError(err);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    loadData(1,25);
  }, []);

  const projectsList = useMemo(
    () =>
      projects.items.map((item: OwnedProject) => (
        <li key={item.uuid} className={styles.myOwnedProjects__item}>
          <MyOwnedProject project={item} setIsModalActive={setIsModalActive}
            setProjectUuid={setProjectUuid}/>
        </li>
      )),
    [projects.items]
  );
  return (
    <Container>
      <Section className={styles.myOwnedProjects}>
        <div className={styles.myOwnedProjects__list}>
          <ul className={styles.myOwnedProjects__ul}>
            {loading && <Loader />}
            {projectsList}
          </ul>
          {loading || projects.items.length === 0 && (
            <li className={styles.myOwnedProjects__container}>
                Сделок пока нет
            </li>
          )}
        </div>
        <PaymentScheduleModal
          active={isModalActive}
          onClose={() => setIsModalActive(false)}
          projectUuid={projectUuid}
          setLoading={setModalLoading}/>
        {modalLoading && (<Loader/>)}
        {/*<aside className={styles.myOwnedProjects__faq}>*/}
        {/*  <h2 className={styles.myOwnedProjects__faqTitle}>FAQ</h2>*/}

        {/*  <ul className={styles.myOwnedProjects__faqList}>*/}
        {/*    {Array.from({length: 8}).map((_, index) => (*/}
        {/*      <li key={index} className={styles.myOwnedProjects__faqItem}>*/}
        {/*        <span className={styles.myOwnedProjects__faqQuestion}>*/}
        {/*          Что такое краудлендинг?*/}
        {/*        </span>*/}
        {/*        <button*/}
        {/*          type="button"*/}
        {/*          className={styles.myOwnedProjects__faqToggle}*/}
        {/*          aria-label="Показать ответ"*/}
        {/*        >*/}
        {/*          <span className={styles.myOwnedProjects__faqPlus}>+</span>*/}
        {/*        </button>*/}
        {/*      </li>*/}
        {/*    ))}*/}
        {/*  </ul>*/}
        {/*</aside>*/}
      </Section>
    </Container>
  );
};

export default MyOwnedProjects;